module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DIV', [_c('Row', [_c('Col', {
    class: (_vm.toggleTable == false) ? 'hidden' : '',
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": _vm.toggleTable == true ? 12 : 0
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "ghost",
      "disabled": (_vm.editingDataRow != null) && (_vm.editingDataRow.val.id == null)
    },
    on: {
      "click": _vm.newEditingDataRowOnClick
    }
  }, [_vm._v("Создать новую запись")])], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": _vm.toggleTable == true ? 12 : 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('Button', {
    staticClass: "top-panel-toggle-mainmenu-button",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.toggleCollapseTableOnClick
    }
  }, [_c('Icon', {
    attrs: {
      "type": _vm.toggleTable == false ? 'chevron-right' : 'chevron-left'
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    class: (_vm.toggleTable == false) ? 'hidden' : '',
    staticStyle: {
      "height": "100%",
      "padding-right": "20px"
    },
    attrs: {
      "span": _vm.toggleTable == true ? 12 : 0
    }
  }, [((_vm.options.viewType == null) || (_vm.options.viewType == 'standardTable')) ? _c('div', {
    staticClass: "entity-manager",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "padding-right": "16px",
      "padding-top": "0px",
      "border-spacing": "0px"
    }
  }, [_c('tr', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.options.tableColumns), function(column, keyColumn) {
    return _c('th', {
      key: keyColumn,
      staticStyle: {
        "padding": "5px 10px 5px 5px",
        "font-weight": "normal",
        "border-bottom": "1px solid #ccc"
      },
      attrs: {
        "width": column.width,
        "align": "left"
      }
    }, [_vm._v("\n            " + _vm._s(column.title) + "\n          ")])
  }), _vm._v(" "), (_vm.options.disableDelete != true) ? _c('th', {
    staticStyle: {
      "font-weight": "normal",
      "border-bottom": "1px solid #ccc"
    },
    attrs: {
      "width": "86px",
      "align": "left"
    }
  }, [_vm._v("Действия")]) : _c('th', {
    staticStyle: {
      "font-weight": "normal",
      "border-bottom": "1px solid #ccc"
    },
    attrs: {
      "width": "17px",
      "align": "left"
    }
  }, [_vm._v(" ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "entity-manager-scroll"
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "padding-top": "0px",
      "border-spacing": "0px"
    }
  }, _vm._l((_vm.data), function(itemData, keyData) {
    return _c('tr', {
      key: keyData,
      staticStyle: {
        "width": "100%",
        "height": "32px"
      },
      style: ({
        background: (_vm.isRowSelected(itemData) ? 'rgb(108,118,175)' : ''),
        color: (_vm.isRowSelected(itemData) ? 'rgb(240,240,240)' : '')
      }),
      on: {
        "click": function($event) {
          _vm.dataRowOnSelect(itemData)
        }
      }
    }, [_vm._l((_vm.options.tableColumns), function(column, keyColumn) {
      return _c('td', {
        key: keyColumn,
        staticStyle: {
          "font-size": "14px",
          "padding": "5px 10px 0px 5px"
        },
        attrs: {
          "width": column.width,
          "align": "left"
        }
      }, [_vm._t("dataItemFieldTableView", [_vm._v(" Нет данных ")], {
        dataRow: itemData,
        column: column
      })], 2)
    }), _vm._v(" "), (_vm.options.disableDelete != true) ? _c('td', {
      staticStyle: {
        "font-size": "14px",
        "padding": "5px 10px 0px 5px"
      },
      attrs: {
        "width": "70px",
        "align": "left"
      }
    }, [_c('Button', {
      staticStyle: {
        "border-radius": "0px",
        "margin": "0px",
        "padding": "0px",
        "color": "rgb(149,158,165)",
        "font-size": "17px"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.deleteEditingDataRowOnClick(itemData)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "trash-b"
      }
    })], 1)], 1) : _vm._e()], 2)
  }))])]) : (_vm.options.viewType == 'draggTreeview') ? _c('div', {
    staticClass: "entity-manager",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "entity-manager"
    }
  }, [_c('dragg-treeview', {
    attrs: {
      "data": _vm.draggableData,
      "options": _vm.draggTreeviewOptions,
      "selectedDataItem": _vm.selectedDataRow
    },
    on: {
      "update:data": function($event) {
        _vm.draggableData = $event
      },
      "change": _vm.draggableDataOnChange,
      "select": _vm.dataRowOnSelect,
      "delete": _vm.deleteEditingDataRowOnClick
    },
    scopedSlots: _vm._u([{
      key: "propertyBox",
      fn: function(viewProps) {
        return [_vm._t("dataItemFieldTableView", [_vm._v(" Нет данных ")], {
          dataRow: viewProps.dataRow
        })]
      }
    }])
  })], 1) : _vm._e()]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "padding": "10px 20px 30px 20px",
      "border-left": "0px solid #ccc"
    },
    attrs: {
      "span": _vm.toggleTable == true ? 12 : 24
    }
  }, [(_vm.editingDataRow != null) ? _c('div', [_vm._l((_vm.options.editorFields), function(item, key) {
    return _c('div', {
      key: key,
      staticStyle: {
        "width": "100%"
      }
    }, [(item != '___') ? _c('div', {
      staticStyle: {
        "width": "100px",
        "padding-bottom": "10px",
        "display": "inline-block",
        "float": "left"
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.options.editorFields[key] + ':')
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-bottom": "10px",
        "display": "inline-block",
        "clear": "left"
      },
      style: (item != '___' ? 'width:calc(100% - 100px)' : 'width:100%')
    }, [_vm._t("dataItemFieldEditView", [_vm._v(" Нет данных ")], {
      editingDataRow: _vm.editingDataRow,
      fieldItem: item,
      fieldKey: key
    })], 2)])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "30px 0px 0px 0px"
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.saveEditingDataRowOnClick
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": _vm.cancelEditingDataRowOnClick
    }
  }, [_vm._v("Отменить")])], 1)], 2) : _c('div', [_vm._v("\n      * Выберите запись для просмотра или редактирования\n    ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-689eaf0c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/technical/components/EntityManager.vue
// module id = 378
// module chunks = 0